import { styled } from '@mui/material';
import { CaretDown, CaretUp } from '@phosphor-icons/react';

export const ScrollStyled = styled('div')({
  overflowX: 'auto',
  alignItems: 'center',
  whiteSpace: 'nowrap',
  boxShadow: 'none',
  marginRight: '30px',
  '@media (max-width: 743px)': {
    display: 'none',
  },
});

export const FooterStyled = styled('footer')({
  '@media (max-width: 743px)': {
    justifyContent: 'center',
  },
});

export const ExpandStyled = styled(CaretDown)({
  fontSize: '2rem',
});

export const CollapseStyled = styled(CaretUp)({
  fontSize: '2rem',
});

export const ComparePlanDetailsMenuStyled = styled('button')({
  marginBottom: '20px',
  backgroundColor: 'transparent',
  paddingLeft: '12px',
  paddingRight: '12px',
});

export const PlanCompareListContainerStyled = styled('div')({
  display: 'table',
  marginBottom: '20px',
  width: '100%',
  borderBottom: '1px solid #e6e6e6',
  padding: '0 12px',
});

export const PlanCompareDetailsStyled = styled('div')({
  display: 'table-row',
  justifyContent: 'space-between',
  '&:last-child > *': {
    borderBottom: 'none',
  },
  '&:first-child > *': {
    paddingTop: '0px',
  },
  '& > *': {
    display: 'table-cell',
    verticalAlign: 'top',
    paddingTop: '12px',
    paddingBottom: '12px',
    borderBottom: '1px solid #e6e6e6',
  },
  '& > *:first-child': {
    paddingLeft: '14px',
  },
  '& > *:last-child': {
    paddingRight: '10px',
  },
});

export const PlanCompareCarrierNameStyled = styled('span')({
  color: '#56638a',
  verticalAlign: 'middle',
});
